import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import ScheduleInactive from "./ScheduleInactive";
import SchedulePage from "./SchedulePage";
import SchedulesAvailable from "./SchedulesAvailable";

class ScheduleRouter extends Component {
  render() {
    const { match } = this.props;

    return (
      <Switch>
        <Route component={SchedulesAvailable} path={`${match.path}/available`} />
        <Route component={SchedulePage} path={`${match.path}/assign`} />
        <Route component={ScheduleInactive} path={`${match.path}/inactive`} />
        <Redirect to={`${match.path}/available`} />
      </Switch>
    );
  }
}

export default ScheduleRouter;
